import {
	Component,
	Injector,
} from '@angular/core';

import {
	UntypedFormControl,
	NgForm,
} from '@angular/forms';

import { UIRouter } from '@uirouter/angular';
import { finalize } from 'rxjs/operators';

import { CommonBaseComponent } from '../../../Common/components/base.component';
import { CommonUserDataService } from '../../../Common/services/user_data.service';

import { AuthenticationMeetingsErrorService } from '../authentication/services/authentication.meetings.error.service';
import {
	AuthenticationMeetingsUserService,
	IAuthenticationMeetingsUserActionsResponse,
} from '../authentication/services/authentication.meetings.user.service';
import { MeetingsAuthAnimation } from '../animation/animation';
import { IAuthenticationMeetingsRegistration } from '../authentication/authentication.interfaces';
import { CommonAppDataService } from '../../../Common/services/app_data/app_data.service';

@Component({
	selector: 'authentication-meetings-registration',
	templateUrl: './authentication.meetings.registration.component.pug',
	animations: [
		MeetingsAuthAnimation,
	],
})
export class AuthenticationMeetingsRegistrationComponent extends CommonBaseComponent {
	state = {
		isLoading: false,
	};

	data: IAuthenticationMeetingsRegistration = {
		FirstName: '',
		MiddleName: '',
		LastName: '',
		PhoneNumber: '',
		Email: '',
		IsUserAgreementConsentGiven: false,
		IsPrivacyPolicyConsentGiven: false,
		Password: '',
	};

	userAgreementText: string;
	privacyPolicyText: string;

	resource = {
		validationCustomErrors: {
			custom: '',
			minLength: this.instant('meetings_auth.forms.registration.controls.password.messages.minlength'),
		},
	};

	onChangeFieldHandler = this.authenticationMeetingsErrorService.onChangeFieldHandler;

	constructor (
		protected injector: Injector,
		private authenticationMeetingsErrorService: AuthenticationMeetingsErrorService,
		private authenticationMeetingsUserService: AuthenticationMeetingsUserService,
		private commonAppData: CommonAppDataService,
		private commonUserDataService: CommonUserDataService,
		private router: UIRouter,
	) {
		super(injector);

		this.userAgreementText = this.getUserAgreementText();
		this.privacyPolicyText = this.getPrivacyPolicyText();
	}

	register (form: NgForm) {
		if (form.valid) {
			this.state.isLoading = true;

			this.authenticationMeetingsUserService
				.register(this.data)
				.pipe(
					finalize(() => this.state.isLoading = false),
				)
				.subscribe((response: IAuthenticationMeetingsUserActionsResponse) => {
					if (response.IsSuccess) {
						this.commonUserDataService.setDataByPath(response.Result.ExpiresAt, 'nextPhoneConfirmationAttemptTime');
						this.commonUserDataService.setDataByPath(this.data.PhoneNumber, 'phoneNumber');

						this.router.stateService.go('confirm');
					} else {
						this.authenticationMeetingsErrorService.handleSuccessResponse(
							{
								...response,
								// CTB-1803
								ErrorMessages: [response.ErrorMessages!.join('\n\n')],
							},
							this.resource.validationCustomErrors,
							form.controls.password as UntypedFormControl,
						);
					}
				});
		}
	}

	getUserAgreementText (): string {
		const href = 'docs/user_agreement.pdf';
		const label = this.instant('meetings_auth.forms.registration.terms_links.user_agreement.link');
		const link = `<a target="_blank" href="${ href }" class="b-authentication-form-link">${ label }</a>`;

		return this.instant('meetings_auth.forms.registration.terms_links.user_agreement.text', { userAgreement: link });
	}

	getPrivacyPolicyText (): string {
		const href = 'docs/privacy_policy.pdf';
		const label = this.instant('meetings_auth.forms.registration.terms_links.privacy_policy.link');
		const link = `<a target="_blank" href="${ href }" class="b-authentication-form-link">${ label }</a>`;

		return this.instant('meetings_auth.forms.registration.terms_links.privacy_policy.text', { privacyPolicy: link });
	}

	getAboutUrl (): string {
		return this.commonAppData.getDataByPath('aboutPage') || '';
	}
}
